import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.247 8.18453L7.30953 12.122C7.2689 12.1627 7.22065 12.195 7.16754 12.217C7.11442 12.239 7.05749 12.2503 7 12.2503C6.9425 12.2503 6.88557 12.239 6.83246 12.217C6.77935 12.195 6.7311 12.1627 6.69047 12.122L2.75297 8.18453C2.67088 8.10244 2.62476 7.9911 2.62476 7.875C2.62476 7.7589 2.67088 7.64756 2.75297 7.56547C2.83506 7.48338 2.9464 7.43726 3.0625 7.43726C3.1786 7.43726 3.28994 7.48338 3.37203 7.56547L6.5625 10.7565V2.1875C6.5625 2.07147 6.60859 1.96019 6.69064 1.87814C6.77269 1.79609 6.88397 1.75 7 1.75C7.11603 1.75 7.22731 1.79609 7.30936 1.87814C7.39141 1.96019 7.4375 2.07147 7.4375 2.1875V10.7565L10.628 7.56547C10.7101 7.48338 10.8214 7.43726 10.9375 7.43726C11.0536 7.43726 11.1649 7.48338 11.247 7.56547C11.3291 7.64756 11.3752 7.7589 11.3752 7.875C11.3752 7.9911 11.3291 8.10244 11.247 8.18453Z",
		fill: "currentColor"
	})
});
export default SvgArrowDown;
